import { render, staticRenderFns } from "./Tenants.vue?vue&type=template&id=09287a58"
import script from "./Tenants.vue.ts?vue&type=script&lang=ts&external"
export * from "./Tenants.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports